<template>
  <v-app id="inspire">
    <v-main>
      <div id="login" class="d-flex min-h-screen">
          <div class="d-flex flex-1 flex-column align-center justify-center py-14 px-2 white">
            <div class="mx-auto w-full max-w-sm lg:w-96">
              <v-alert flat v-if="error" type="error">
                Verifique os dados de acesso informados.
              </v-alert>
              <div class="titulo pb-20">
                <img
                  class=""
                  src="@/assets/img/logo_brand.png"
                  alt=""
                />
              </div>
              <h2 class="titulo pb-5 mb-lg-4">
                Sistema de Gestão de Frota
              </h2>
              <v-form>
                <v-text-field
                  label="Usuário" name="username" v-model="user.username"
                  v-mask="maskUsername" prepend-inner-icon="mdi-account"
                  type="text" outlined
                />
                <v-text-field
                  id="password" label="Senha" name="password" v-model="user.password"
                  prepend-inner-icon="mdi-lock" outlined
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                />
              </v-form>

              <a href="#" class="float-right pb-4">Esqueceu a senha?</a>

              <v-btn block large :loading="loading" color="teal" depressed dark
                :disabled="loading" @click="login" class="rounded-lg">Entrar
              </v-btn>
            </div>
          </div>

          <div class="d-none d-lg-block relative w-0 flex-1">
            <img
              class="absolute inset-0 h-full w-full object-cover"
              src="@/assets/img/bg_login_01.jpg"
              alt=""
            />
          </div>
        </div>
    </v-main>
  </v-app>
</template>

<script>
import tokenServices from '@/services/util/token';
import { mask } from 'vue-the-mask';

export default {
  directives: {
    mask,
  },
  name: 'app.login',
  metaInfo: {
    title: 'Autenticação',
    // all titles will be injected into this template
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    showPassword: false,
    loading: false,
    error: false,
    maskUsername: '###.###.###-##',
    user: {
      username: '',
      password: '',
    },
  }),
  methods: {
    login() {
      this.loading = true;
      tokenServices
        .accessToken(this.user.username, this.user.password)
        .then(() => {
          this.$router.push({ name: 'app.dashboard' });
        })
        .catch(() => {
          this.$swal('Erro', 'Verifique os dados de acesso informados.', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
